import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const TermsAndConditions = () => {
    return (
        <div className='gradient-background '>
            <Box className="logo-box-terms">
                <Box>
                    <img src={'/assets/showcasaNew.svg'} alt="logo" className="logoImage-terms" />
                </Box>
            </Box>
            <div
                className="privacy-policy"
            >
                <h1 style={{ textAlign: 'start', marginBottom: '10px' }}>
                    Terms and Conditions for ShowcasaAI
                </h1>

                <p style={{ marginBottom: "40px" }}><strong>Effective Date:</strong> 26-Jan-2025</p>

                <p style={{ marginBottom: "40px" }}>
                    Welcome to ShowcasaAI ("the Web App"). By accessing or using our platform,
                    you agree to be bound by the following Terms and Conditions. If you do not
                    agree to these terms, you may not use the platform. This includes
                    provisions for various aspects of operation, ensuring users fully
                    understand their rights, responsibilities, and limitations while
                    interacting with the platform. These Terms and Conditions aim to create a
                    secure, fair, and transparent environment for all users.
                </p>

                <h2>1. Acceptance of Terms</h2>
                <p>
                    By registering for or using ShowcasaAI, you agree to comply with and be
                    legally bound by these Terms and Conditions. These terms apply to all
                    users, including visitors, registered users, and purchasers of services.
                </p>

                <h2>2. Services Provided</h2>
                <p>ShowcasaAI enables users to:</p>
                <ul>
                    <li>Upload personal images and request AI-generated images based on their imagination.</li>
                    <li>Upload product images to generate showcase images in various imagined locations.</li>
                </ul>
                <p>
                    All outputs are created using advanced artificial intelligence technologies,
                    and results may vary based on input quality and AI interpretation.
                </p>

                <h2>3. Usage of AI Technology</h2>
                <h3>3.1 AI Output Disclaimer</h3>
                <p>
                    The AI-generated images are provided "as is" and are based on the inputs
                    provided by the user. While we strive to deliver high-quality results, the
                    Web App cannot guarantee specific outcomes, accuracy, or suitability for
                    any particular purpose. Generated content may not replicate exact real-world
                    environments, appearances, or product placements.
                </p>

                <h3>3.2 User Responsibility</h3>
                <p>
                    You acknowledge that AI outputs are based on algorithms and interpretations.
                    As a user, you are responsible for ensuring that your inputs comply with
                    applicable laws and do not infringe on third-party rights. Any misuse of the
                    platform, including uploading objectionable, illegal, or copyrighted
                    materials without authorization, is strictly prohibited.
                </p>

                <h3>3.3 Content Rights and Usage</h3>
                <p>
                    By uploading content, you grant ShowcasaAI a non-exclusive, royalty-free,
                    and worldwide license to process, use, and store the content solely for
                    generating outputs requested by you. ShowcasaAI does not claim ownership of
                    the uploaded content or the generated results but retains the right to
                    anonymize and use data for service improvement and research.
                </p>

                <h2>4. Payment and Refund Policy</h2>
                <h3>4.1 Credits and Payments</h3>
                <p>
                    Users are required to purchase credits to utilize certain features of the
                    platform, such as training AI models and generating images. All payments
                    are final and non-refundable, regardless of the outcome or satisfaction with
                    the AI-generated content.
                </p>

                <h3>4.2 No Refunds</h3>
                <p>
                    Payments made to ShowcasaAI are non-refundable under any circumstances,
                    including but not limited to dissatisfaction with the results or accidental
                    purchases.
                </p>

                <h2>5. User Conduct</h2>
                <p>You agree not to:</p>
                <ul>
                    <li>Upload content that is illegal, harmful, defamatory, obscene, or infringes on intellectual property rights.</li>
                    <li>Exploit or reverse-engineer the platform’s AI technology.</li>
                    <li>Use the platform for purposes that violate any applicable laws or regulations.</li>
                </ul>

                <h2>6. Privacy Policy</h2>
                <p>
                    Your privacy is important to us. Please review our <a href="/privacy-policy" style={{ color: '#00BFFF' }}>Privacy Policy</a>
                    for details on how we collect, use, and protect your information.
                </p>

                <h2>7. Intellectual Property</h2>
                <p>
                    All technology, algorithms, and methodologies used within ShowcasaAI remain
                    the intellectual property of ShowcasaAI and its affiliates. You are granted
                    a limited, non-exclusive, non-transferable license to use the platform for
                    its intended purposes.
                </p>

                <h2>8. Limitation of Liability</h2>
                <p>
                    ShowcasaAI is not liable for any direct, indirect, incidental, or
                    consequential damages resulting from your use of the platform or reliance on
                    AI-generated content. The platform is provided on an "as is" basis, and we
                    do not guarantee uninterrupted access or error-free functionality.
                </p>

                <h2>9. Termination</h2>
                <p>
                    We reserve the right to terminate or suspend your access to the platform at
                    our discretion, without notice, if you violate these Terms and Conditions.
                </p>

                <h2>10. Governing Law</h2>
                <p>
                    These Terms and Conditions are governed by and construed in accordance with
                    the laws of Karnataka, India. Any disputes arising from these terms
                    shall be subject to the exclusive jurisdiction of the courts of Karnataka, India.
                </p>

                <h2>11. Changes to Terms</h2>
                <p>
                    ShowcasaAI reserves the right to modify these Terms and Conditions at any
                    time. Changes will be effective immediately upon posting, and continued use
                    of the platform constitutes acceptance of the revised terms.
                </p>

                <h2>12. Contact Us</h2>
                <p>
                    ShowcasaAI is developed, maintained, and owned by AgilizTech Software
                    Services Pvt Ltd, Bangalore, India. If you have any questions or concerns
                    about these Terms and Conditions, please contact us at <a href="mailto:support@showcasaai.io" style={{ color: '#00BFFF' }}>support@showcasaai.io</a>.
                </p>

                <p>
                    By using ShowcasaAI, you acknowledge that you have read, understood, and
                    agreed to these Terms and Conditions.
                </p>
            </div>
        </div>

    );
};

export default TermsAndConditions;
